// extracted by mini-css-extract-plugin
export var centerText = "_fi-8";
export var container = "_fi-0";
export var doughnutContainer = "_fi-7";
export var legend = "_fi-a";
export var legendItemColorDisplay = "_fi-b";
export var legendItemLabel = "_fi-d";
export var legendItemValue = "_fi-c";
export var lg = "_fi-5";
export var maxWidth = "_fi-9";
export var md = "_fi-4";
export var responsive = "_fi-6";
export var sm = "_fi-3";
export var xs = "_fi-2";
export var xxs = "_fi-1";